export var DATE_FORMAT = 'dd.MM.yyyy';
export var TIME_FORMAT = 'HH:mm';
export var DATETIME_FORMAT = 'dd.MM.yyyy HH:mm';
export var DATETIME_SERVER = "yyyy-MM-dd'T'HH:mm:ssxx"; // eslint-disable-line quotes

export var SHORT_DATE_FORMAT = 'yyyy-MM';
export var MONTH_FULL_NAME_FORMAT = 'LLLL';
export var MONTH_YEAR_FORMAT = 'MM-yyyy';